import React from "react";
import classNames from 'classnames';

export interface MarkdownBuilderProps {
    text: string;
    applyBrandingClass?: boolean;
    linkColor?: string;

}

export const MarkdownBuilder: React.FC<MarkdownBuilderProps> = ({
    text,
    applyBrandingClass,
    linkColor
}: MarkdownBuilderProps) => {

    const containerClass = classNames({
        'chat-footer__branding': applyBrandingClass,
    });

    const linkRegex = /\[(.*?)\]\((.*?)\)/g;
    const boldRegex = /\*\*(.*?)\*\*/g;
    const headerRegex = /^(#{1,6}) (.*?)(?=\n|$)/gm;

    const parsedText = text.replace(linkRegex, (_match, linkText, url) => {
        return `<a style="color: ${linkColor || ''}; text-decoration: underline;" href="${url}" target="_blank" rel="noopener noreferrer">${linkText}</a>`;
    }).replace(boldRegex, (_match, boldText) => {
        return `<b>${boldText}</b>`;
    }).replace(headerRegex, (_match, hashes, headerText) => {
        const level = hashes.length;
        return `<h${level}>${headerText}</h${level}>`;
    });

    return (
        <div className={containerClass} dangerouslySetInnerHTML={{ __html: parsedText }}>
        </div>
    );
};